import './MediaTile.css'

import type { ReactNode } from 'react'

import { cx } from '../utilities/cx'

export type MediaTileProps = {
  className?: string
  imageSrc?: string
  imageAlt?: string
  badge?: ReactNode
  title?: string
  meta?: ReactNode
  footer?: ReactNode
  onClick?: () => void
}

export const MediaTile = (props: MediaTileProps) => {
  const { className, imageSrc, imageAlt = '', badge, title, meta, footer, onClick } = props

  const content = (
    <>
      <div className="media-tile__image-wrap">
        {imageSrc ? (
          <img className="media-tile__image" src={imageSrc} alt={imageAlt} />
        ) : (
          <div className="media-tile__image media-tile__image--placeholder" />
        )}
        {badge && <div className="media-tile__badge">{badge}</div>}
      </div>
      {(title || meta) && (
        <div className="media-tile__body">
          {title && <div className="media-tile__title">{title}</div>}
          {meta && <div className="media-tile__meta">{meta}</div>}
        </div>
      )}
      {footer && <div className="media-tile__footer">{footer}</div>}
    </>
  )

  if (onClick) {
    return (
      <button
        type="button"
        className={cx('media-tile', 'media-tile--button', className)}
        onClick={onClick}
      >
        {content}
      </button>
    )
  }

  return <div className={cx('media-tile', className)}>{content}</div>
}
